<template lang="html">
  <div id="description-page">
    <section class="breadcrumb-section">
      <div class="container oversized-container">
        <span>Producto</span>
        <span class="line">/</span>
        <span>{{ product.name }}</span>
      </div>
    </section>

    <section class="container oversized-container description-section" id="product-description">
      <div class="row">

        <div class="col-lg-6 col-gallery" v-if='!icecat'>
          <swiper :options="galleryOptions">
            <swiper-slide v-for="(row, galIndex) in gallery" :key="galIndex">
              <div class="image-container">
                <div class="img">
                  <v-zoom :img="row" width="100%"></v-zoom>
                </div>
              </div>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>

        <b-form class="col-lg-6 col-description" @submit.prevent="quantityValidate()">
          <!-- <div class="bar-fav">
            <button type="button" class="btn-fav" @click="$refs['modal-whatsapp'].show();">
              <i class="t-150 fa-solid fa-square-share-nodes txt-icon"></i>
            </button>

            <div v-if="$root.logged">
              <button v-if="favorite" type="button" class="btn-fav actived" @click="addFavorite()"><i class="icon"></i></button>
              <button v-if="!favorite" type="button" class="btn-fav" @click="addFavorite()"><i class="icon"></i></button>
            </div>
          </div> -->

          <h1 class="name">{{ product.name }}</h1>
          
          <div v-if="product.offer_price">
            <h4 class="price discount"><span>$ {{ product.price }}</span></h4>
            <h4 class="price f-w-700">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.offer_price) }}</h4>
          </div>
          <div v-else>
            <h4 class="price f-w-700">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }}</h4>
          </div>

          <p class="mt-3 extra-breadcrumb">
            <span><strong class="f-w-600">SKU: </strong> {{ product.sku }}<br /></span>
          </p>
          <p class="mt-2 extra-breadcrumb">
            <!-- <span v-if="product.category"><strong class="f-w-600">Categoria: </strong> <router-link class="buble" target="_blank" :to="'/categoria/'+$root._converToURL(product.category.name, product.category.id)">{{ product.category.name }}</router-link> <br /></span> -->
            <span v-if="product.category"><strong class="f-w-600">Categoria: </strong> <span class="buble">{{ product.category.name }}</span> <br /></span>
          </p>
          <p class="mt-3 mb-2 extra-breadcrumb">
            <span v-if="product.subcategory"><strong class="f-w-600">Subcategoria: </strong> <router-link class="buble" target="_blank" :to="'/subcategoria/'+$root._converToURL(product.subcategory.name, product.subcategory.id)">{{ product.subcategory.name }}</router-link> <br /></span>
          </p>
          <p class="mt-3 extra-breadcrumb" v-if="product.equivalence">
            <span><strong class="f-w-600">Equivalencia: </strong> {{ product.equivalence }}<br /></span>
          </p>

          <div class="pt-1 extra-breadcrumb">
            <span class="mr-1" v-if="product.width"><strong>Ancho:</strong> {{ product.width }} cm. </span>
            <span class="mr-1" v-if="product.height"><strong>Alto:</strong> {{ product.height }} cm. </span>
            <span class="mr-1" v-if="product.length"><strong>Largo:</strong> {{ product.length }} cm. </span>
            <span class="mr-1" v-if="product.diameter"><strong>Diametro:</strong> {{ product.diameter }}. </span>
            <span class="mr-1" v-if="product.weight"><strong>Peso:</strong> {{ product.weight }} kg. </span>
            <!-- <span class="mr-1" v-if="product.material"><strong>Material:</strong> {{ product.material }}.</span> -->
          </div>

          <div class="mb-2 box-info-inline">
            <p class="mt-2 extra-breadcrumb" v-if="product.marca">
              <span><strong class="f-w-600">Marca:</strong></span> <router-link class="buble" target="_blank" :to="'/marca/'+$root._converToURL(product.marca, product.marca_id)"> {{ product.marca }}</router-link>
            </p>
            <p class="mt-2 extra-breadcrumb" v-if="product.modelo">
              <span><strong class="f-w-600">Modelo:</strong></span> <router-link class="buble" to="">{{ product.modelo }}</router-link>
            </p>
            <p class="mt-2 extra-breadcrumb" v-if="product.motor">
              <span><strong class="f-w-600">Motor:</strong></span> <router-link class="buble" to="">{{ product.motor }}</router-link>
            </p>
          </div>

          <div class="box-info-inline">
            <p class="mt-2 extra-breadcrumb" v-if="product.anioInicio">
              <span><strong class="f-w-600">Año inicio:</strong></span> <router-link class="buble" to="">{{ product.anioInicio }}</router-link>
            </p>
            <p class="mt-2 extra-breadcrumb" v-if="product.anioFin">
              <span><strong class="f-w-600">Año fin:</strong></span> <router-link class="buble" to="">{{ product.anioFin }}</router-link>
            </p>
          </div>

          <div class="mt-3 mb-3 accordion-no-border" role="tablist" v-if="product.application">
            <b-card no-body v-if="product.application.length > 0">
              <b-card-header header-tag="header" role="tab">
                <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-appl><i class="fa-regular fa-file-lines mr-1"></i> Aplicaciones <i class="icon"></i></h6>
              </b-card-header>

              <b-collapse id="accordion-appl" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <div class="txt-description">
                    <div class="d-block mb-3" v-for="(ap, apInx) in product.application" :key="'apInx-'+apInx">
                      <h6 class="txt-c-secondary f-w-700">{{ ap.brand.name }} - {{ ap.brandmodel.name }}</h6>
                      
                      <p class="extra-breadcrumb">
                        <span class="mr-2"><strong class="f-w-600">Marca: </strong> {{ ap.brand.name }}</span>
                        <span class="mr-2"><strong class="f-w-600">Marca: </strong> {{ ap.brandmodel.name }}</span>
                        <span class="mr-2"><strong class="f-w-600">Motor: </strong> {{ ap.motor.name }}</span><br />
                        <span class="mr-2"><strong class="f-w-600">Año inicio: </strong> {{ ap.year_start }}</span>
                        <span class="mr-2"><strong class="f-w-600">Año fin: </strong> {{ ap.year_end }}</span>
                      </p>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card class="mt-2" no-body v-if="product.description">
              <b-card-header header-tag="header" role="tab">
                <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-1><i class="fa-regular fa-file-lines mr-1"></i> Descripción <i class="icon"></i></h6>
              </b-card-header>

              <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <div class="txt-description" v-html="product.description"></div>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card class="mt-2" no-body v-if="product.specs">
              <b-card-header header-tag="header" role="tab">
                <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-3><i class="fa-regular fa-file-lines mr-1"></i> Especificaciones <i class="icon"></i></h6>
              </b-card-header>

              <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <div class="txt-description" v-html="product.specs"></div>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card class="mt-2" no-body v-if="product.faqs">
              <b-card-header header-tag="header" role="tab">
                <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-4><i class="fa-regular fa-file-lines mr-1"></i> Preguntas frecuentes <i class="icon"></i></h6>
              </b-card-header>

              <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <div class="txt-description" v-html="product.faqs"></div>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- <b-card class="mt-2" no-body>
              <b-card-header header-tag="header" role="tab">
                <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-2><i class="fa-regular fa-circle-play"></i> Video <i class="icon"></i></h6>
              </b-card-header>

              <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <div class="box-video">
                    <iframe src="https://www.youtube.com/embed/Tr61nTQOL2E?si=t_X_MkVbDffZWQ8H" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card> -->
          </div>

          <!-- <div class="mt-1 extra-breadcrumb" v-if="product.ancho">Ancho: {{ product.ancho }} cm</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.alto">Alto: {{ product.alto }} cm</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.largo">Largo: {{ product.largo }} cm</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.volumen">Volumen: {{ product.volumen }}</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.peso">Peso: {{ product.peso }} kg</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.material">Material: {{ product.material }}</div> -->

          <h6 class="mt-2 subtitle" v-if="product.ficha">Ficha tecnica</h6>
          <div class="txt-description" v-if="product.ficha" v-html="product.ficha"></div>

          <h6 class="subtitle" v-if="product.color">Color</h6>
          <h4 class="price" v-if="product.color">{{ product.color }}</h4>
          <p class="mt-2 extra-breadcrumb" v-if="product.stock">
            <strong class="txt-blue f-w-700">Disponibles: {{ product.stock }}</strong>
          </p>
          <div class="out-of-stock" v-else style="width: 100px;padding: 4px 14px 5px 14px;color: #ffffff;font-size: 0.8rem;font-weight: 500;text-align: center;background-color: #f43c3c;">Agotado</div>

          <h6 class="mt-3 subtitle" v-if="product.stock">Cantidad</h6>
          <div class="row no-gutters pt-1 box-options" v-if="product.stock">
            <div class="col col-short">
              <b-form-input v-model="form.quantity" type="number" class="text-center" required></b-form-input>
            </div>
          </div>

          <div class="d-block mt-4 mb-2" v-if="product.pdf">
            <a class="btn btn-submit btn-contact" v-if="product.pdf" :href="product.pdf" target="_blank" rel="noopener noreferrer">PDF <i class="fa fa-file-pdf-o"></i></a>
          </div>

          <div class="col-12 my-2">
            <div class="row">
              <div class="col-sm-6 my-2 px-0 pr-sm-4" v-if="product.stock">
                <b-button type="submit" class="w-100 btn-submit">Agregar al carrito <i class="far fa-shopping-cart"></i></b-button>
              </div>

              <div class="col-sm-6 my-2 px-0">
                <router-link class="w-100 btn btn-submit btn-contact" :to="{ name: 'contactoPage', query: { p: product.name+', SKU: '+product.sku } }">Contactar <i class="far fa-envelope"></i></router-link>
              </div>
            </div>
          </div>

          <!-- <h6 class="subtitle">Inventarios</h6>
          <div class="col-12 mt-2 col-extra" id="col-extra">
            <table id="stocktable">
                <tr>
                  <th>Almacen</th>
                  <th>Stock</th>
                </tr>
                <tr v-for="(st,indx) in product.stocks" :key="indx">
                  <td>{{st.warehouse}}</td>
                  <td>{{st.stock}}</td>
                </tr>
            </table>
          </div> -->
          <!-- <h6 class="subtitle">Compartir</h6>
          <div class="col-12 mt-2 col-extra" id="col-extra">
            <div class="row">
              <div class="col b-print">
                <h6>Imprimir</h6>
                <div class="btn-q" @click="printDiv('product-description')"><span><i class="fas fa-print"></i></span></div>
              </div>

              <div class="col px-0 b-sharing">
                <ShareNetwork
                  v-for="(network, pdInx) in networks"
                  :network="network.network"
                  :key="network.network"
                  :style="{backgroundColor: network.color}"
                  :url="sharing.url"
                  :title="sharing.title"
                  :description="sharing.description"
                  :quote="sharing.quote"
                  :hashtags="sharing.hashtags"
                  :twitterUser="sharing.twitterUser">
                  <div class="btn-q"><span><i :class="network.icon"></i></span></div>
                </ShareNetwork>
              </div>
            </div>
          </div> -->
        </b-form>

        <!-- <div class="col-12 mb-2">
          <div class="col-12 px-0 col-s-title">
            <h2 class="title">Comentarios</h2>
            <hr class="mt-2 mb-0" />
          </div>
        </div> -->

        <!-- <div class="col-lg-6 col-comment-form">
          <div class="col-12 col-comments">
            <b-form class="box-comment" @submit="addComment">
              <h5 class="subt">Califica este producto</h5>

              <div class="box-stars">
                <b-form-rating inline required v-model="comment.stars" stars="5"></b-form-rating>
              </div>

              <div class="box-input">
                <b-form-textarea v-model="comment.body" placeholder="Escribe tu comentario" required rows="2" max-rows="2"></b-form-textarea>

                <p class="mt-2 text-right">
                  <b-button type="submit" class="btn-co">Comentar</b-button>
                </p>
              </div>
            </b-form>
          </div>
        </div>

        <div class="col-lg-6 mt-3 col-all-comments">
          <div class="wr-comments" v-if="comments.length">
            <div class="row">

              <div class="col-12 col-total-comments" v-if="avg > 0">
                <div class="box"><small>TOTAL:</small> {{ Math.ceil(avg) }}</div>
              </div>

              <div class="col-12 col-comments">
                <div class="row">
                  <div class="col-lg-6 col-comment" v-for="(item, coprInx) in comments" :key="'coprInx-'+coprInx">
                    <div class="box">
                      <div class="box-stars">
                        <b-form-rating v-model="item.star" readonly inline></b-form-rating>
                      </div>

                      <div class="box-comment">{{ item.comment }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-11 mx-auto col-extrainfo" v-if="icecat">
            <div id="Container5"></div>
            <div id="Container7"></div>
            <div id="Container11"></div>
        </div> -->

      </div>

    </section>

    <section class="container oversized-container related-products-section" id="related-products">
      <div class="row">
        <div class="col-12 px-2 col-s-title">
          <h2 class="text-center title" v-if="products.length">Te podría interesar</h2>
          <hr class="mt-2 mb-2" />
        </div>
      </div>

      <div class="row">
        <div class="col-12 px-0 col-products">
          <swiper class="swiper carousel-t1 ct1-white" :options="productsOption">
            <swiper-slide v-for="(product, index) in products" :key="index">
              <div class="col-12 px-0 sample-product shad-prod">
                <a class="outlined-box">
                  <router-link class="fake-link" :to="'/producto/'+$root._converToURL(product.name, product.id)"></router-link>
                  <div class="box-image">
                    <div class="out-of-stock" v-if="product.stock < 1">Agotado</div>

                    <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+product.image+')' }">
                      <img src="public/images/shared/empty.png" >
                    </div>
                  </div>

                  <div class="box-shot-descr">
                    <h6 class="brand">{{ product.sku }}</h6>
                    <h6 class="name">{{ product.name }}</h6>
                    <!-- <h6 class="brand">{{ product.brand }}</h6> -->
                    <h6 class="price discount" v-if="product.offer_price"><span>{{ product.offer_price }}</span></h6>
                    <h6 class="price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }}</h6>
                  </div>

                  <cart-component :product="product"></cart-component>
                </a>
              </div>
            </swiper-slide>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>

    </section>

    <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
        <div v-html="modal.msg"></div>
        <div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
            <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close()">Agregar mas productos</b-button>
            <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close(); $router.push('/cart')">Ir al carrito <i class="color-white fas fa-shopping-cart"></i></b-button>
        </div>
    </sweet-modal>

    <b-modal modal-class="modal-whatsapp" ref="modal-whatsapp" hide-footer centered title="">
      <div class="box-service">
        <h5 class="title">Compartir en redes sociales</h5>

        <div class="col px-0 mt-2 b-sharing">
          <ShareNetwork
            v-for="(network, pdInx) in networks"
            :network="network.network"
            :key="network.network"
            :style="{backgroundColor: network.color}"
            :url="sharing.url"
            :title="sharing.title"
            :description="sharing.description"
            :quote="sharing.quote"
            :hashtags="sharing.hashtags"
            :twitterUser="sharing.twitterUser">
            <div class="btn-q"><span><i :class="network.icon"></i></span></div>
          </ShareNetwork>

          <!-- <a class="btn-q b-extra" target="_blank" href="https://api.whatsapp.com/send?text=Hules%20Becerra%0D%0Ahttps%3A%2F%2Fhulesbecerra.com%2F%23%2Fproducto%2F%0D%0AEsto%20es%20un%20ejemplo%20de%20descripción">
            <span><i class="fa-brands fa-whatsapp"></i></span>
          </a> -->
        </div>
      </div>
    </b-modal>

    <LoadingFullComponent v-if="isLoading"></LoadingFullComponent>
  </div>
</template>

<script>
import LoadingFullComponent from '../shared/loading-full-component.vue';
import vZoom from 'vue-zoom';
export default {
  components: {vZoom, LoadingFullComponent},

  data() {
    return {
      id: null,
      isLoading: true,

      form: {
        quantity: 1,
      },

      gallery: [
        // 'public/images/pages/products/product-8.jpg',
        // 'public/images/pages/products/product-9.jpg',
      ],

      product: {
        id: null,
        name: null,
        sku: 'OD52SD0SR',
        category_id: '5',
        category: 'Categoría 1',
        subcategory_id: '5',
        subcategory: 'Subcategoría 1',
        price: '350',
        marca_id: 1,
        marca: 'Marca Y',
        modelo: 'Modelo X',
        motor: 'Motor V12',
        anioInicio: '2018',
        anioFin: '2022',
        description: '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>',
        stock: 35,
        ancho: 15,
        alto: 50,
        largo: 52,
        peso: 0.90,
        stocks:[],
      },
      category: [],
      products: [
        // {
        //   "id": 1,
        //   "sku": "LUCC111",
        //   "name": "EJEMPLO DE NOMBRE DE PRODUCTO AQUÍ, CON MAXIMO DE 3 LINEAS",
        //   "price": "3050.00",
        //   "stock": 1,
        //   "imageUrl": "public/images/pages/products/product-1.jpg"
        // },
      ],
      sizes: [],
      size: [],
      stock: 0,
      avg: 0,
      favorite: false,
      icecat: false,

      // == Sharing ==
      sharing: {
        url: 'https://hulesbecerra.com/#/producto/',
        title: 'Hules Becerra',
        description: 'Esto es un ejemplo de descripción',
        quote: 'Esto es el Quote',
        hashtags: 'this,isthe,hashtag',
        twitterUser: 'twitter'
      },

      networks: [
        { network: 'twitter', name: 'Twitter', icon: 'fa-brands fa-x-twitter' },
        { network: 'facebook', name: 'Facebook', icon: 'fa-brands fa-facebook-f' },
        // { network: 'pinterest', name: 'Pinterest', icon: 'fab fa-pinterest-p' },
        { network: 'whatsapp', name: 'WhatsApp', icon: 'fa-brands fa-whatsapp' },
      ],
      // == ==

      colors: [],

      relatedProducts: [],

      comments: [],

      modal:{
        msg:'',
        icon:'',
        block:false
      },

      comment:{
        stars: null,
        body: ''
      },

      // == Carrusel options ==
      galleryOptions: {
        loop: false,
        speed: 600,

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false
        // }
      },

      productsOption: {
        loop: false,
        slidesPerView: 5,
        spaceBetween: 10,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1399: {
            slidesPerView: 5
          },
          1199: {
            slidesPerView: 4
          },
          991: {
            spaceBetween: 10,
            slidesPerView: 3
          },
          575: {
            spaceBetween: 10,
            slidesPerView: 2
          },
          1: {
            slidesPerView: 1
          },
        }
      },
      // == ==
    }
  },

  watch: {
    "$route.params.id" : function(v){
      //this.id = this.$route.params.id;
      this.id = this.$root._getURLID(this.$route.params.id);
      this.getProduct();
    }
  },

  methods:{
    toast(title, msg, variant) {
      this.$bvToast.toast(msg, {
        title: title,
        toaster: 'b-toaster-bottom-right',
        variant: variant,
        solid: true,
        appendToast: true
      })
    },

    // getComments(id){
    //   axios.get(tools.url('/api/comments/'+id)).then((response)=>{
    //     this.comments = response.data.comments;
    //     this.avg = response.data.avg;

    //   }).catch((error)=>{
    //     console.log(error);
    //   })
    // },

    // addComment: function(){
    //     axios.post(tools.url("/api/comments/"+this.product.id),{stars:this.comment.stars, comment:this.comment.body}).then((response) => {
    //         this.comment.stars = null;
    //         this.comment.body = '';
    //         this.getComments(this.id);
    //     }).catch((error) => {
    //         alert("Error al agregar comentario");
    //         console.log(error);
    //     })
    // },

    quantityValidate(){
        if(this.form.quantity > this.product.stock){
          let w = 'piezas';
          if(this.product.stock <= 1){ 
            w = 'pieza';
          }
          this.toast('Error', 'Este artículo cuenta con maximo '+this.product.stock+' '+w+' en existencia', 'danger');
        }else{
            this.stock = this.product.stock;
            this.addCart();
        }
    },

    getProduct(){
      this.isLoading = true;
      axios.get(tools.url('/api/products/' + this.id)).then((response)=>{
        this.product = {};
        this.gallery = [];
        this.product = response.data;
        this.category = response.data.category;
        this.gallery = response.data.gallery;

        if(this.product.stock > 0){
          this.form.quantity = 1;
        }

        this.getRelated(this.product.id);
        this.isLoading = false;
        //this.getComments(this.product.id);
      }).catch((error)=>{
        console.log(error);
      });
    },

    addCart(){
      var cart = [];
      var encontrado = false;

      if(this.form.quantity > 0){
          if(localStorage.cart){
            cart = JSON.parse(localStorage.getItem('cart'));

            for(var i = 0; i < cart.length ; i++){
              if(cart[i].id == this.id){
                var suma = Number(cart[i].quantity) + Number(this.form.quantity);
                cart[i].quantity = suma <= this.stock ? suma : this.stock;
                encontrado = true;
                break;
              }
            }

            if(!encontrado){
              cart.push({ id:this.id, quantity:this.form.quantity });
            }
          } else{
            cart.push({ id:this.id, quantity:this.form.quantity });
          }

          localStorage.setItem("cart",JSON.stringify(cart));
          this.$root.cartCount = cart.length;
          this.modal.msg = 'El producto <b>'+this.product.name+'</b> se agregado al carrito con '+this.form.quantity+' piezas';
          this.modal.icon = 'success';
          this.$refs.modal.open();
      }

    },

    getRelated(id){
      axios.get(tools.url('/api/products/related/'+id)).then((response)=>{
        this.products = response.data;
      }).catch((error)=>{
        console.log(error);
      })
    },

    getFavorite: function(){
        if(this.$root.user.id){
            axios.post(tools.url('/api/favorite'),{ product_id: this.id }).then((response)=>{
                if(response.data == 'true'){
                    this.favorite = true;
                }else{
                    this.favorite = false;
                }
                this.favoritesCount();
            }).catch((error)=>{
                console.log(error);
            });
        }
    },

    addFavorite: function(){
        if(this.$root.user.id){
            axios.post(tools.url('/api/addFavorite'),{product_id: this.id }).then((response)=>{
                this.favorite = response.data.favorite;
                this.favoritesCount();
            }).catch((error)=>{
                console.log(error);
            });
        }
    },

    favoritesCount: function(){
        if(this.$root.user.id){
            axios.get(tools.url('/api/favoritesCount')).then((response)=>{
                this.$root.favoriteCount = response.data;
            }).catch((error)=>{
                console.log(error);
            })
        }
    }

  },

   mounted(){
    // this.id = this.$route.params.id;
    this.id = this.$root._getURLID(this.$route.params.id);
    
    this.getProduct();

    /*if(this.$root.logged == true){
        this.getFavorite();
    }*/
  }
}
</script>
<style>
#stocktable table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#stocktable td {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
#stocktable th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
  background-color: #dddddd;
}
</style>
